module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "banner.bd219035.svg" + "?" + Date.now();